import React from 'react'
import BannerList from '../banner_components/banner_list'

export default function Main() {
  return (
    <div className=''>
      <BannerList />
    </div>
  )
}
